import { render, staticRenderFns } from "./CourseDetailPage.vue?vue&type=template&id=3fb649ba&scoped=true&"
import script from "./CourseDetailPage.vue?vue&type=script&lang=ts&"
export * from "./CourseDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./CourseDetailPage.vue?vue&type=style&index=0&id=3fb649ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb649ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VContent})
